export const topicsData = [
  { id: 1, tag: '科幻巨制', label: '科幻', heat: 9823, desc: '最新科幻大片持续更新中' },
  { id: 2, tag: '悬疑烧脑', label: '悬疑', heat: 8756, desc: '高能反转剧情合集' },
  { id: 3, tag: '国剧精选', label: '国剧', heat: 9120, desc: '热门国产剧一网打尽' },
  { id: 4, tag: '动漫番剧', label: '动漫', heat: 7689, desc: '新番连载同步追更' },
  { id: 5, tag: '动作猛片', label: '动作', heat: 8456, desc: '肾上腺素飙升体验' },
  { id: 6, tag: '喜剧合家欢', label: '喜剧', heat: 7123, desc: '笑到停不下来' },
  { id: 7, tag: '恐怖惊悚', label: '恐怖', heat: 6543, desc: '胆小慎入系列' },
  { id: 8, tag: '韩剧热播', label: '韩剧', heat: 8876, desc: '高分韩剧全集收录' },
  { id: 9, tag: '纪录纪实', label: '纪录', heat: 5432, desc: '真实世界深度探索' },
];

export const commentsData = [
  { id: 1, name: '影迷小张', avatar: '张', text: '画质真的太棒了，蓝光超清一点都不卡，比别家强太多了！用了三个月，看片体验一直很稳定。', time: '2小时前', rating: 5 },
  { id: 2, name: '追剧达人', avatar: '追', text: '资源更新速度很快，新剧当天就能看。界面也很清爽，没有乱七八糟的广告弹窗，体验很好。', time: '5小时前', rating: 5 },
  { id: 3, name: '电影控老王', avatar: '王', text: '片库很全，很多老片子都能找到高清版本。收藏和播放记录功能很实用，推荐给身边朋友了。', time: '1天前', rating: 4 },
  { id: 4, name: '深夜看片人', avatar: '夜', text: '手机端观看也很流畅，地铁上追剧完全不卡。蓝光画质在手机上显示效果也很惊艳，给力！', time: '2天前', rating: 5 },
];

export const mediaData = [
  { id: 1, title: '星际征途：新纪元', category: '科幻冒险', views: '128万', duration: '2h 18m', desc: '人类文明在宇宙深处的最后希望，一场跨越星系的史诗冒险' },
  { id: 2, title: '暗夜追踪者', category: '悬疑犯罪', views: '96万', duration: '1h 52m', desc: '连环案件背后的惊天阴谋，每一个细节都可能是破局关键' },
  { id: 3, title: '长安十二时辰', category: '古装历史', views: '215万', duration: '48集', desc: '盛世长安暗流涌动，忠义之士誓死守护黎明前的最后希望' },
  { id: 4, title: '极限速度：疾风', category: '动作竞速', views: '87万', duration: '2h 05m', desc: '地下赛车世界的光荣与梦想，速度与激情的极致碰撞' },
];

export const indexData = [
  { id: 1, title: '2025暑期档强片速递', count: 32, tag: '热映' },
  { id: 2, title: '豆瓣高分华语电影合集', count: 56, tag: '精选' },
  { id: 3, title: 'Netflix原创剧集全收录', count: 48, tag: '独家' },
  { id: 4, title: 'IMDb Top250 完整片库', count: 250, tag: '经典' },
  { id: 5, title: '日漫新番同步追更专区', count: 28, tag: '连载' },
  { id: 6, title: '奥斯卡获奖影片大全', count: 94, tag: '获奖' },
  { id: 7, title: '国产剧年度口碑排行', count: 41, tag: '排行' },
  { id: 8, title: '韩剧高分全集一次看完', count: 67, tag: '热播' },
];

export const carouselData = [
  { id: 1, title: '《星际穿越》十周年纪念', subtitle: '诺兰科幻神作，跨越时空的父女情深', tag: '科幻经典', imgSeq: 'carousel-01' },
  { id: 2, title: '暑期档重磅：《封神第二部》', subtitle: '神话史诗续作，视觉奇观全面升级', tag: '热映推荐', imgSeq: 'carousel-02' },
  { id: 3, title: '国产悬疑剧天花板来了', subtitle: '《三大队》导演新作，迷雾重重层层反转', tag: '新剧速递', imgSeq: 'carousel-03' },
  { id: 4, title: '日漫神作《葬送的芙莉莲》', subtitle: '治愈系冒险史诗，豆瓣9.4分口碑炸裂', tag: '动画精选', imgSeq: 'carousel-04' },
  { id: 5, title: '韩剧《黑暗荣耀》全集上线', subtitle: '宋慧乔复仇爽剧，年度现象级话题之作', tag: '全集放送', imgSeq: 'carousel-05' },
  { id: 6, title: '蓝光修复：王家卫电影全集', subtitle: '花样年华、重庆森林等经典4K重制', tag: '经典重温', imgSeq: 'carousel-06' },
];

export const featuresData = [
  { id: 1, icon: 'ri-4k-fill', title: '蓝光超清画质', desc: '支持4K HDR超高清播放，杜比全景声，每一帧都如临其境，享受影院级的视听盛宴' },
  { id: 2, icon: 'ri-speed-up-fill', title: '极速缓冲不卡顿', desc: '全球CDN加速节点覆盖，智能码率自适应技术，任何网络环境都能流畅播放不缓冲' },
  { id: 3, icon: 'ri-film-fill', title: '海量片库日更', desc: '收录超过十万部影视资源，每日更新最新上映影片和剧集，你想看的这里全都有' },
  { id: 4, icon: 'ri-device-fill', title: '全设备无缝观看', desc: '电脑、手机、平板、电视全平台适配，播放记录云端同步，随时随地继续追剧' },
];

export const rankingData = [
  { rank: 1, title: '星际征途：新纪元', type: '电影', heat: '986万', trend: 'up' },
  { rank: 2, title: '长安十二时辰', type: '电视剧', heat: '873万', trend: 'up' },
  { rank: 3, title: '暗夜追踪者', type: '电影', heat: '759万', trend: 'down' },
  { rank: 4, title: '极限速度：疾风', type: '电影', heat: '682万', trend: 'up' },
  { rank: 5, title: '藏海花', type: '电视剧', heat: '591万', trend: 'new' },
];

export const aboutData = {
  title: '关于97影院',
  content: '97影院致力于为全球华语观众提供最优质的高清影视在线观看服务。我们拥有庞大的正版高清片库，涵盖最新院线电影、热门电视剧、经典老片、动漫番剧、纪录片等多个品类。平台采用先进的视频压缩与传输技术，确保在任何网络环境下都能实现蓝光超清画质的流畅播放。自成立以来，97影院始终坚持以用户体验为核心，不断优化播放技术和内容更新速度，让每一位影视爱好者都能在这里找到想看的、享受极致的视觉盛宴。',
  stats: [
    { value: '100,000+', label: '影视资源' },
    { value: '5,000万+', label: '累计用户' },
    { value: '99.9%', label: '播放成功率' },
    { value: '24h', label: '新片上线速度' },
  ],
};

export const faqData = [
  { id: 1, q: '97影院的视频画质如何？需要付费吗？', a: '97影院提供蓝光超清画质在线播放，支持1080P和4K分辨率。平台所有内容均为免费观看，无需注册会员，无需付费订阅，打开网站即可畅享高清影视体验。' },
  { id: 2, q: '为什么观看时不会卡顿缓冲？', a: '我们采用了全球分布式CDN加速网络和智能自适应码率技术，系统会根据您的网络状况自动调整最佳播放参数，确保视频流畅不中断。同时我们持续优化服务器集群，即使高峰时段也能保持稳定播放。' },
  { id: 3, q: '影视资源更新速度怎么样？', a: '97影院的更新团队7×24小时不间断工作，院线电影下映后最快48小时内上线高清版本；热门电视剧和综艺节目一般在播出当天即可同步更新。新番动漫也会在播出后数小时内完成字幕制作和上线。' },
  { id: 4, q: '可以在手机上观看吗？支持投屏吗？', a: '97影院全面适配手机、平板和电脑浏览器，您可以在任何设备上流畅观看。平台还支持DLNA和AirPlay投屏协议，可以一键将影片投射到智能电视上观看，享受大屏震撼体验。' },
  { id: 5, q: '片库内容涵盖哪些类型？有中文字幕吗？', a: '我们的片库涵盖科幻、动作、悬疑、喜剧、恐怖、爱情、动画、纪录片等所有主流类型，同时收录了华语、好莱坞、日韩、欧洲等多地区影视作品。所有外语影片均配备高质量中文字幕，部分热门影片还提供中英双语字幕。' },
];

export const updatesData = [
  { id: 1, date: '2025-07-31', title: '《星际征途：新纪元》蓝光高清版上线', desc: '科幻巨制蓝光版本现已加入片库，支持4K HDR画质' },
  { id: 2, date: '2025-07-30', title: '播放器升级：新增记忆续播功能', desc: '系统自动记录观影进度，下次打开可从上次断开处继续播放' },
  { id: 3, date: '2025-07-28', title: '暑期档专题页面上线', desc: '收录2025年暑期所有热门院线大片和热播剧集' },
  { id: 4, date: '2025-07-25', title: '日漫新番《咒术回战》第三季同步更新', desc: '每周五晚同步更新最新集数，中文字幕准时上线' },
  { id: 5, date: '2025-07-22', title: '片库突破十万部里程碑', desc: '感谢所有用户的支持，片库数量正式突破十万部大关' },
  { id: 6, date: '2025-07-20', title: '移动端观看体验全面优化', desc: '手机端播放器重构，加载速度提升40%，流量消耗降低30%' },
  { id: 7, date: '2025-07-18', title: '《藏海花》全集上线，会员抢先看', desc: '南派三叔IP改编大剧，悬疑探险题材年度力作' },
  { id: 8, date: '2025-07-15', title: 'CDN节点新增东南亚地区覆盖', desc: '海外华人用户观看体验大幅提升，延迟降低至100ms以内' },
  { id: 9, date: '2025-07-12', title: '蓝光修复专区上线：经典老片焕新', desc: '首批上线50部华语经典电影4K修复版，致敬光影岁月' },
];

export const cardsData = [
  { id: 1, title: '追剧清单：2025年必看国剧', desc: '从悬疑到古装，十部口碑炸裂的国产剧，每一部都值得细细品味。高清全集已收录，随时随地畅享追剧乐趣。', tag: '国剧推荐', imgSeq: 'card-01' },
  { id: 2, title: '科幻迷的天堂：硬核科幻电影合集', desc: '从经典到新作，从太空歌剧到赛博朋克，精选全球最值得看的科幻电影，蓝光画质带你遨游星辰大海。', tag: '科幻合集', imgSeq: 'card-02' },
  { id: 3, title: '周末电影马拉松：高分悬疑片单', desc: '反转再反转，全程无尿点。精心挑选的高分悬疑电影，让你的周末充满紧张刺激的观影体验。', tag: '悬疑精选', imgSeq: 'card-03' },
  { id: 4, title: '动漫爱好者必看：年度最佳番剧', desc: '热血、治愈、奇幻、恋爱，各类高分动漫番剧一网打尽，日漫迷不可错过的追番指南。', tag: '动漫精选', imgSeq: 'card-04' },
  { id: 5, title: '韩剧控的快乐：高分全集一次追完', desc: '从甜宠到复仇，从悬疑到治愈，精选高分韩剧全集，不用等更新一口气看到大结局。', tag: '韩剧合集', imgSeq: 'card-05' },
  { id: 6, title: '动作片爱好者：肾上腺素飙升之选', desc: '枪战、格斗、飙车、爆炸，精选全球最刺激的动作猛片，每一部都让你热血沸腾停不下来。', tag: '动作猛片', imgSeq: 'card-06' },
];

export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '精选专题', href: '#cards' },
  { label: '移动观影', href: '#app' },
  { label: '热播榜单', href: '#ranking' },
  { label: '精彩推荐', href: '#media' },
];